import axios from "axios";
import router from '../../router/index';
import { handlePaginatedResponse } from '../helpers/paginationState';

export const state = {
    save_status: false,
    filter_status: false,
    consumable: [],
    consumable_stock: [],
    consumable_usage: {
        data: [],
        meta: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 50,
            to: 0,
            total: 0
        }
    },
    consumable_cart: [],
    consumable_usage_cart: [],
    creditors:[],
    stock_movements:[],
    purchaseId:"",
    usage_details: []
};
export const getters = {
    SaveStatus: state => state.save_status,
    filterStatus: state => state.filter_status,
    Consumables: state => state.consumable.data,
    ConsumablesStock: state => state.consumable_stock.data,
    ConsumablesUsage: state => state.consumable_usage.data,
    ConsumablesUsagePagination: state => state.consumable_usage.meta,
    ConsumablesCart: state => state.consumable_cart.data,
    ConsumablesUsageCart: state => state.consumable_usage_cart.data,
    Creditors: state => state.creditors.data,
    StockMovement: state => state.stock_movements.data,
    UsageDetails: state => state.usage_details.data,
};

export const mutations = {
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
    SET_FILTER_STATUS(state, newValue) {
        state.filter_status = newValue
    },
    SET_CONSUMABLE(state, newValue) {
        state.consumable = newValue
    },
    SET_CONSUMABLE_STOCK(state, newValue) {
        state.consumable_stock = newValue
    },
    SET_CONSUMABLE_USAGE(state, response) {
        handlePaginatedResponse(state.consumable_usage, response);
        state.consumable_usage = { ...state.consumable_usage };
    },
    RESET_CONSUMABLE_USAGE(state) {
        state.consumable_usage.data = [];
        state.consumable_usage.meta = { current_page: 1, from: 1, last_page: 1, per_page: 50, to: 0, total: 0 };
    },
    SET_CONSUMABLE_CART(state, newValue) {
        state.consumable_cart = newValue
    },
    SET_CONSUMABLE_USAGE_CART(state, newValue) {
        state.consumable_usage_cart = newValue
    },
    SET_CREDITORS(state, newValue) {
        state.creditors = newValue
    },
    SET_STOCK_MOVEMENT(state, newValue) {
        state.stock_movements = newValue
    },
    SET_PURCHASES_ID(state, newValue) {
        state.purchaseId = newValue
    },
    SET_USAGE_DETAILS(state, newValue) {
        state.usage_details = newValue
    },   
};

export const actions = {
    
    fetchConsumables({ commit }, payload) {
        commit('SET_FILTER_STATUS', true)
        axios.get(`consumables`, { params: payload }).then(ec_res => {
            commit('SET_FILTER_STATUS', false)
            commit('SET_CONSUMABLE', ec_res.data)
        })
    },

    fetchProductConsumables({ commit }, payload) {
        axios.get(`fetch_item_consumables`, payload).then(ec_res => {
            commit('SET_CONSUMABLE', ec_res.data)
        })
    },

    addConsumables({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('consumables',payload).then(() => {
            dispatch('fetchConsumables');
            let message = { 'msg': `Consumable Item ${payload.name} added successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Consumable Item "+error }
            dispatch('notification/error', message, { root: true })
        })
    },
    editConsumables({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`consumables/${payload.id}`, payload).then(() => {
            dispatch('fetchConsumables');
            let message = { 'msg': `Consumable Item ${payload.name} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Consumable Item" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteConsumables({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`consumables/${payload.id}`).then(() => {
            dispatch('fetchConsumables');
            let message = { 'msg': `Consumable Item ${payload.name} deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch((error) => {
            commit('SET_CONSUMABLE', false)
            let message = { 'msg': "Error in deleting Consumable Item "+error }
            dispatch('notification/error', message, { root: true })
        })
    },


    // ====================== CONSUMABLES STOCKING ========================
    fetchConsumablesStock({ commit }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.get(`consumables_stock`, {params: payload}).then(ec_res => {
            commit('SET_SAVE_STATUS', false);
            commit('SET_CONSUMABLE_STOCK', ec_res.data)
        })
    },
    // Consumables Cart
    fetchConsumablesCart({ commit }) {
        axios.get(`consumable_cart`).then(ec_res => {
            commit('SET_CONSUMABLE_CART', ec_res.data)
        })
    },

    addToConsumableCart({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('add_tocart',payload).then(() => {
            dispatch('fetchConsumablesCart');
            let message = { 'msg': `Consumable Item added to cart successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Consumable Item to cart "+error }
            dispatch('notification/error', message, { root: true })
        })
    },
    editConsumableCart({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`cart_edit/${payload.id}`, payload).then(() => {
            dispatch('fetchConsumablesCart');
            let message = { 'msg': `Consumable Item ${payload.name} updated successfully in cart` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Consumable Item in cart" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteConsumableCart({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`cart_delete/${payload.id}`).then(() => {
            dispatch('fetchConsumablesCart');
            let message = { 'msg': `Consumable Item ${payload.name} deleted from cart successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch((error) => {
            commit('SET_CONSUMABLE_CART', false)
            let message = { 'msg': "Error in deleting Consumable Item from cart "+error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Consumables stocking
    addConsumableStock({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('consumables_stock',payload).then(() => {
            dispatch('fetchConsumablesCart');
            let message = { 'msg': `Consumable Item stock added successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
            dispatch('fetchConsumablesCart');
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Consumable Item to stock "+error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // save and print
    addConsumableStockPrint({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('consumables_stock',payload).then((response) => {
            if (response.status == 200) {                
                commit('SET_PURCHASES_ID', response.data.id)
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to record Purchase" }
                dispatch('notification/error', message, { root: true })
            }
            commit('SET_SAVE_STATUS', false); 
            dispatch('fetchConsumablesCart');
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Consumable Item to stock "+error }
            dispatch('notification/error', message, { root: true })
        })
    },


    // ====================== CONSUMABLES USAGE ========================
    fetchConsumablesUsage({commit,dispatch}, payload) {
        commit('SET_FILTER_STATUS', true);
        let apiPayload = { ...payload };
        apiPayload.page = payload.page || 1;
        apiPayload.per_page = payload.per_page || 50;

        // Build query parameters
        const params = new URLSearchParams();
        Object.keys(apiPayload).forEach(key => {
            if (apiPayload[key] !== '' && apiPayload[key] !== 0) {
                params.append(key, apiPayload[key]);
            }
        });

        const queryString = params.toString();
        const apiUrl = queryString ? `consumables_usage?${queryString}` : 'consumables_usage';

        axios.get(apiUrl).then(response => {            
            commit('SET_CONSUMABLE_USAGE', response.data)
            commit('SET_FILTER_STATUS', false);
        }).catch(() => {
            commit('SET_CONSUMABLE_USAGE', { data: [], meta: { total: 0 } });
            commit('SET_FILTER_STATUS', false);
            let errorMsg = 'Failed to load Consumables usage report.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },

    // Consumables usage
    addConsumableUsage({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('consumables_usage',payload).then(() => {
            dispatch('fetchConsumablesUsageCart');
            let message = { 'msg': `Consumable Item usage added successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Rcording Consumable Item usage "+error }
            dispatch('notification/error', message, { root: true })
        })
    },
   
    editConsumablesUsage({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`consumables_usage/${payload.id}`, payload).then(() => {
            dispatch('fetchConsumables');
            let message = { 'msg': `Consumable Item Usage ${payload.name} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Consumable Item Usage" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteConsumablesUsage({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`consumables_usage/${payload.id}`).then(() => {
            dispatch('fetchConsumablesUsage');
            let message = { 'msg': `Consumable Item Usage${payload.name} deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in deleting Consumable Item "+error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Consumables Cart
    fetchConsumablesUsageCart({ commit }) {
        axios.get(`consumableusage_cart`).then(ec_res => {
            commit('SET_CONSUMABLE_USAGE_CART', ec_res.data)
        })
    },

    addToConsumableUsageCart({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('addusage_tocart',payload).then(() => {
            dispatch('fetchConsumablesUsageCart');
            let message = { 'msg': `Consumable Item isage added to cart successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Consumable Item usage to cart "+error }
            dispatch('notification/error', message, { root: true })
        })
    },
    editConsumableUsageCart({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`usagecart_edit/${payload.id}`, payload).then(() => {
            dispatch('fetchConsumablesUsageCart');
            let message = { 'msg': `Consumable Item usage of ${payload.name} updated successfully in cart` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Consumable Item usage in cart" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteConsumableUsageCart({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`usagecart_delete/${payload.id}`).then(() => {
            dispatch('fetchConsumablesUsageCart');
            let message = { 'msg': `Consumable Item usage of ${payload.name} deleted from cart successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false); 
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in deleting Consumable Item usage from cart "+error }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchCreditors({ commit }, payload) {
        commit('SET_FILTER_STATUS', true)        
        axios.post('consumable_creditors', payload).then(total => {
            commit('SET_FILTER_STATUS', false)
            commit('SET_CREDITORS', total.data)
        })
    },

    // Clear credit
    ClearCredit({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`pay_consumablecredit/${payload.id}`, payload).then((response) => {
            if (response.status == 200) {                
                commit('SET_PURCHASES_ID', response.data.id)
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to clear Credit" }
                dispatch('notification/error', message, { root: true })
            }
            dispatch('fetchCreditors');
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Clearing Credit" }
            dispatch('notification/error', message, { root: true })
        })
    },

    addConsumableUnit({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('consumable_units', payload).then((resp) => {
            dispatch('fetchConsumables');
            if (resp.status == 201) {
                let message = resp.data.message;
                alert(message);
                dispatch('notification/error', message, { root: true })
            } else {
                let message = { 'msg': `Consumable Unit ${payload.unit} added successfully` }
                dispatch('notification/success', message, { root: true })
            }
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Consumable " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Edit Consumable
    editConsumableUnit({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`consumable_units/${payload.id}`, payload).then(() => {
            dispatch('fetchConsumables');
            let message = { 'msg': `Consumable Unit ${payload.unit} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Consumable Unit " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Delete Consumable
    deleteConsumableUnit({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`consumable_units/${payload.id}`).then(() => {
            dispatch('fetchConsumables');
            let message = { 'msg': `Consumable Unit ${payload.name} deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // change default Consumable unit
    changeDefaultUnit({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('change_consumablebase_unit', payload).then((resp) => {
            dispatch('fetchConsumables');
            if (resp.status == 200) {
                let message = { 'msg': `Consumable Unit ${payload.name} set as default for Consumable ${payload.Consumable}` }
                dispatch('notification/success', message, { root: true })
                commit('SET_SAVE_STATUS', false);
            } else if (resp.status == 201) {
                let message = { 'msg': "Error! " + resp.message }
                dispatch('notification/error', message, { root: true })
                commit('SET_SAVE_STATUS', false);
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error changing default Consumable Unit" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Stock roconciliation
    addQty({ commit,dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post(`reconcile_consumables`, payload).then(() => {
            dispatch('fetchConsumables');
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
        })
    },

    SaveReconcile({ commit, dispatch }) {
        commit('SET_SAVE_STATUS', true);
        axios.post(`save_consumablesreconcile`).then(() => {
            dispatch('fetchConsumables');
            let message = { 'msg': `Consumables Stock Reconciled successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in Consumables Reconciling Stock" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchStockMovements({ commit }, id) {
        axios.get(`consumables_stockmovement/${id}`).then(ec_res => {
            commit('SET_STOCK_MOVEMENT', ec_res.data)
        })
    },

    editPurchase({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`edit_consumablepurchases/${payload.id}`, payload).then((response) => {
            if (response.status == 200) {
                commit('SET_SAVE_STATUS', false);
                router.push('/consumables/stocking').catch(() => {});
            } else if (response.status == 201) {
                commit('SET_SAVE_STATUS', false);
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })
            }
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Returning Purchase" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deletePurchase({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`delete_consumablepurchases/${payload.id}`).then((response) => {
            commit('SET_SAVE_STATUS', false);
            dispatch('fetchConsumablesStock', payload.filterdata);  
            if (response.status == 200) {
                let message = { 'msg': `Purchase Deleted successfully` }
                dispatch('notification/success', message, { root: true })
            }else if (response.status == 201) {
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })                
            }                      
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Deleting Purchase" }
            dispatch('notification/error', message, { root: true })
        })
    },
    fetchUsageDetails({ commit }, id) {
        commit('SET_FILTER_STATUS', true);
        axios.get(`consumables_usage_details/${id}`).then(ec_res => {
        commit('SET_FILTER_STATUS', false);
        commit('SET_USAGE_DETAILS', ec_res.data)
        })
    },
};